<template>
	<div class="c-dashboard__wrap"
        :data-component-name="$options.name"
	>
		<TimeReportComponent />
	</div>
</template>

<script>
	import TimeReportComponent from "@/components/nav/TimeReport.vue"

	export default {
		name: "TimeReport",
		components: {
			TimeReportComponent
		},
		// props: {
		// },
		// data(){
		// },
		// methods: {
		// },
		// mounted(){
		// },
	}
</script>
